<template>
    <div>
        <div class="content">
            <Header/>
            <v-container>
                <v-layout align-center justify-center>
                    <v-flex lg12 md12 sm12 xs12>
                        <v-row justify-center>
                            <v-col>
                                <p class="text-center">You might have opened the dashboard in another tab, please close this tab.</p>
                            </v-col>
                        </v-row>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import Header from "../login/Header";
    import Footer from "../login/Footer";

    export default {
        name: "InvalidSession",
        components: {Header, Footer}
    }

</script>

<style>
    p {
        font-size: 15px;
    }
</style>
